import * as React from 'react';
import './style.scss';
import './style.scss';
import classNames from 'classnames';
import { Link } from 'gatsby-plugin-react-i18next';
import { CSSProperties } from 'react';

export enum ButtonLinkType {
  NAVIGATION = 'NAVIGATION',
  ANCHOR = 'ANCHOR',
}
export interface Props {
  children: any;
  color:
    | 'transparent'
    | 'light'
    | 'secondary'
    | 'dark'
    | 'primary'
    | 'dark-grey';
  size: 'small' | 'regular' | 'medium' | 'big';
  outlined?: boolean;
  darkMode?: boolean;
  flat?: boolean;
  rounded?: boolean;
  onClick?: () => void;
  className?: string;
  href?: string;
  outerLink?: boolean;
  style?: CSSProperties;
  linkType?: ButtonLinkType;
}

const Button: React.FC<Props> = ({
  color,
  size,
  outlined = false,
  darkMode = false,
  flat = false,
  rounded = false,
  onClick,
  children,
  className = '',
  outerLink,
  style,
  href,
  linkType = ButtonLinkType.NAVIGATION,
}) => {
  let classNameExtended = classNames(
    color,
    size,
    {
      'button-link': href,
      outlined: outlined,
      'outlined-dark': outlined && !darkMode,
      'outlined-light': outlined && darkMode,
      flat: flat,
      rounded: rounded,
    },
    className
  );

  if (!href) {
    return (
      <button style={style} onClick={onClick} className={classNameExtended}>
        {children}
      </button>
    );
  }

  switch (linkType) {
    case ButtonLinkType.NAVIGATION:
      return (
        <Link
          style={style}
          to={href}
          target={outerLink ? '_blank' : 'window'}
          rel={outerLink ? 'noopener' : undefined}
          className={classNameExtended}
          onClick={onClick}
        >
          {children}
        </Link>
      );
    case ButtonLinkType.ANCHOR:
      return (
        <a
          style={style}
          rel={'noreferrer'}
          className={classNameExtended}
          href={href}
        >
          {children}
        </a>
      );
  }
};

export default Button;
